import { createContext, useContext } from "react";

interface MessageContextType {
  message_id: number;
  handleProductClick: (product_sku_code: string) => void;
}

const MessageContext = createContext<MessageContextType | undefined>(undefined);

export const useMessageContext = () => {
  const context = useContext(MessageContext);
  if (!context) {
    throw new Error("useMessageContext must be used within a MessageProvider");
  }
  return context;
};

export const MessageProvider = MessageContext.Provider;
